import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { requestWorkspaceExport } from '@/api/workspaceExport/workspaceExportApi';
import type { WorkspaceExport } from '@/api/workspaceExport/workspaceExportApi.types';
import { WORKSPACE_EXPORT_QUERY_KEY } from '@/constants/queryKeys';

export function useRequestWorkspaceExportMutation(): UseMutationResult<
  WorkspaceExport,
  Error,
  void
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestWorkspaceExport,
    onSuccess: function storeRequestedExport(workspaceExport) {
      queryClient.setQueryData(WORKSPACE_EXPORT_QUERY_KEY, workspaceExport);
    },
    onError: function refreshExportState() {
      queryClient.invalidateQueries({ queryKey: WORKSPACE_EXPORT_QUERY_KEY });
    },
  });
}
